<template>
  <article :class="classes">
    <figure class="ui-card-cart__image">
      <img :src="image.src" :alt="image.alt" />
    </figure>

    <div class="ui-card-cart__content">
      <h3 class="ui-card-cart__content-title">{{ title }}</h3>

      <div class="ui-card-cart__content-text">
        <slot></slot>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  title: string
  image: {
    src: string
    alt?: string
  }
}

defineProps<Props>()

const classes = computed(() => ({
  'ui-card-cart': true,
}))
</script>

<style lang="scss">
@use 'sass:math';
@import '../styles/config';

.ui-card-cart {
  display: flex;
  align-items: flex-start;
}

.ui-card-cart__image {
  position: relative;
  width: 2.5rem;
  margin-right: 0.75rem;
  border-radius: 0.125rem;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    padding-top: percentage(math.div(3, 2));
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: $black;
    opacity: 0;
    @include transition('opacity');
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    @include transition('transform');
  }
}

.ui-card-cart__content {
  flex: 1 1 0%;
}

.ui-card-cart__content-title {
  margin-bottom: 0.25rem;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.015em;
}

.ui-card-cart__content-text {
  p {
    font-family: $font-barlow;
    font-size: 0.875rem;
    line-height: 1.42857143;
    margin: 0;
  }
}
</style>
